export default __webpack_public_path__ + "static/media/img_popular_spaces.0933f36e.svg";